import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import "./checkOut.scss";
import { BackIcon, CallIcon, LocationIcon } from "../../components/Icons";
import { Button, Col, Row } from "react-bootstrap";
import UserImg from "../../assets/images/providerProfileImg.png";
import Form from "react-bootstrap/Form";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addCard,
  calculateTax,
  createJob,
  fetchAuthorizeCustomerProfile,
  fetchProviderServiceDetail,
  verifyCoupons,
} from "../../services/auth.service";
import { setLoader } from "../../slice/commonSlice";
import { toast_error } from "../../config/Constant";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchProviderDetails } from "../../services/hireProvider.service";
import { getFullName } from "../../utils/common";
import moment from "moment";
import SuccessModal from "../../modals/successModal/SuccessModal";
import { selectUser } from "../../slice/authSlice";
import { encryptData } from "../../utils/encryptDecrypt";
import * as cardValidator from "card-validator";
import Acknowlegment from "../../modals/acknowlegment/Acknowlegment";
import authorizelogo from "../../assets/images/Authorize.net_logo.png";
import { Coupon } from "@rsuite/icons";
import { apiUrl } from "../../environment";
const CheckOut = () => {
  const user = useSelector(selectUser);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [chargesDetails, setChargesDetails] = useState({});
  const [profile, setProfile] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const [successResponse, setSuccessResponse] = useState({});
  const [authorizeCustomerProfile, setAuthorizeCustomerProfile] = useState();
  const [cardNumber, setCardNumber] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [couponId, setCouponId] = useState();
  const [discountType, setDiscountType] = useState();
  const [couponDiscount, setCouponDiscount] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [cardMonth, setCardMonth] = useState("");
  const [cardYear, setCardYear] = useState("");
  const [cvv, setCvv] = useState();
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [couponError, setCouponError] = useState(false);
  const [errors, setErrors] = useState({
    cardNumber: "",
    cardYear: "",
    cardCvv: "",
  });

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear; i <= currentYear + 21; i++) {
    years.push(i);
  }
  const [policyChecked, setPolicyChecked] = useState(false);
  const [policyModal, setPolicyModal] = useState(false);
  const [acknowledgment, setAcknowledgment] = useState();
  const [serviceDetails, setServiceDetails] = useState({});
  const checkCard = () => {
    let valid = true;
    const cardNumberValidation = cardValidator.number(cardNumber);
    const expiryDateValidation = cardValidator.expirationDate({
      month: cardMonth,
      year: cardYear,
    });
    const cvvValidation = cardValidator.cvv(cvv);
    let newErros = { ...errors };
    if (!cardNumberValidation.isValid) {
      // alert('Invalid Card Number');
      valid = false;
      newErros.cardNumber = "Invalid card number";
      // return;
    } else {
      newErros.cardNumber = "";
    }

    if (!expiryDateValidation.isValid) {
      valid = false;
      newErros.cardYear = "Invalid card expiry date";
      // return;
    } else {
      newErros.cardYear = "";
    }

    if (!cvvValidation.isValid) {
      valid = false;
      newErros.cardCvv = "Invalid card number";
    } else {
      newErros.cardCvv = "";
    }
    setErrors(newErros);
    return valid;
  };

  const id = location.state?.payload?.providerId;
  useEffect(() => {
    if (
      location.state?.payload?.unitPrice &&
      location.state?.payload?.durationExpected
    ) {
      calculateTaxPrice();
    } else {
      fetchServiceDetails(location.state?.payload?.serviceId);
    }
    getAuthorizeCustomerProfile();
  }, []);

  useEffect(() => {
    if (id) {
      getProfile();
    }
  }, [id]);

  const fetchServiceDetails = async (serviceId) => {
    let payload = {
      providerId: id,
      serviceId: serviceId,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderServiceDetail(payload);
      await dispatch(setLoader(false));
      if (response.data.status) {
        setServiceDetails(response.data.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const getProfile = async () => {
    let payload = {
      _id: id,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchProviderDetails(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setProfile(response.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };
  const calculateTaxPrice = async () => {
    let payload = {
      unitPrice: location.state?.payload?.unitPrice,
      durationExpected: location.state?.payload?.durationExpected,
    };
    await dispatch(setLoader(true));
    try {
      const response = await calculateTax(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setChargesDetails(response.data);
      } else {
        toast.error(response?.data?.message, toast_error);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  //get authorize customer profile
  const getAuthorizeCustomerProfile = async () => {
    let payload = {
      customerProfileId: user?.userCustomerProfileId,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchAuthorizeCustomerProfile(payload);
      await dispatch(setLoader(false));

      if (response.status) {
        setAuthorizeCustomerProfile(response?.data);
        setSelectedCardId(
          response?.data.customerProfile.profile.paymentProfiles[0]
            .customerPaymentProfileId || null
        );
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  const handleSubmit = async () => {
    if (!selectedCardId) {
      toast.error("Please select credit card to proceed further");
    } else if (
      !policyChecked &&
      location.state?.payload?.serviceName == "Child Care"
    ) {
      toast.error(
        "You must accept the Service Provider Certification Acknowledgment before confirming the booking."
      );
      return;
    }

    let payload = location.state.payload;
    payload.paymentProfileId = selectedCardId;
    if (isCouponApplied) {
      payload.couponId = couponId;
      payload.discountType = discountType;
      payload.couponDiscount = couponDiscount;
      payload.couponCode = couponCode;
    }
    await dispatch(setLoader(true));
    try {
      const response = await createJob(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setSuccessModal(true);
        setSuccessResponse(response.data);
      } else {
        toast.error(response?.data?.message, toast_error);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  function fetchDate(isoString) {
    // Check if the input is a valid ISO string
    if (!moment(isoString).isValid()) {
      return "Invalid date";
    }

    // Convert ISO string to the desired format

    // Convert the ISO string to Bermuda local time
    const bermudaTime = moment.tz(isoString, "Atlantic/Bermuda");

    // Format the date in the desired format
    const formattedDate = bermudaTime.format("hh:mm a, DD MMMM, YYYY");

    return formattedDate;
  }

  const handleCardNumber = (value) => {
    value = value.replace(/\s/g, ""); // Remove existing spaces
    value = value.replace(/-/g, ""); // Remove existing dashes

    // Add space or dash after every four digits
    value = value.replace(/(\d{4})(?=\d)/g, "$1 ");

    // Trim extra characters if the length exceeds 19 digits (including spaces)
    value = value.slice(0, 23);
    setCardNumber(value);
  };
  const handleCouponCode = async () => {
    try {
      if (isOpen) {
        dispatch(setLoader(true));

        const payload = {
          serviceId: location.state?.payload.serviceId,
          couponCode: couponCode,
          userId: user.id,
        };

        const response = await verifyCoupons(payload);

        if (response?.data?.success === true) {
          setIsCouponApplied(true);
          setCouponError(false);
          setCouponId(response?.data.discount.couponId);
          setDiscountType(response?.data.discount.discountType);
          setCouponDiscount(response?.data.discount.couponDiscount);
          toast.success("Coupon applied successfully!");
        } else {
          setIsCouponApplied(false);
          setCouponError(true);
        }
      } else {
        setIsOpen(true);
      }
    } catch (error) {
      setIsCouponApplied(false);
      setCouponError(true);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleAddCard = async () => {
    if (checkCard()) {
      const payload = {
        // cardName,
        cardExpirationDate: encryptData(cardMonth + cardYear),
        cvv: encryptData(cvv),
        customerProfileId: user.userCustomerProfileId,
        cardNumber: encryptData(cardNumber.replace(/\s/g, "")),
      };
      await dispatch(setLoader(true));
      try {
        const response = await addCard(payload);
        await dispatch(setLoader(false));
        setCardMonth("");
        setCardNumber("");
        setCardYear("");
        // setCardName("");
        setSelectedCardId(null);
        setCvv("");
        getAuthorizeCustomerProfile();
        if (response?.data?.status) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        await dispatch(setLoader(false));
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleCheck = () => {
    if (!policyChecked) {
      setPolicyModal(true);
    }
    setPolicyChecked(false);
  };

  return (
    <>
      <Header />
      <PageHeading title="Confirm booking" />
      <div className="main-container">
        <div className="checkout-wrapper">
          <div className="back-wrapper" onClick={() => navigate(-1)}>
            <div className="back-icon">
              <BackIcon />
            </div>
            <div className="back-title">CheckOut</div>
          </div>

          <div className="checkout-date-time-wrap">
            <div className="checkout-date-title">Date & Time:</div>
            <div className="checkout-date-time">
              {fetchDate(location.state?.payload?.startTime)}
            </div>
          </div>
          <div className="box-wrapper service-charge-wrapper">
            <div className="service-left">
              <div className="service-user-wrap">
                <div className="service-user-img-wrap">
                  <img
                    src={profile?.personData?.profilePic || UserImg}
                    alt="User"
                  />
                </div>
                <div className="service-name-wrapper">
                  <div className="service-name">
                    {location.state?.payload?.serviceName}
                  </div>
                  <div className="service-name-user">
                    {getFullName(
                      profile?.personData?.firstName,
                      profile?.personData?.lastName
                    )}
                  </div>
                </div>
              </div>

              <div className="service-location-wrap">
                <div className="service-location">
                  <div className="icon-wrap">
                    <LocationIcon />
                  </div>
                  <div className="service-location-text">
                    {profile?.personData?.location}
                  </div>
                </div>
                <div className="service-phone">
                  <div className="icon-wrap">
                    <CallIcon />
                  </div>
                  <div className="service-phone-text">
                    {profile?.personData?.phone}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="service-right">
              {chargesDetails?.charge
                ? `$${chargesDetails?.charge}`
                : `$${serviceDetails?.rate}/hr`}
            </div> */}
          </div>
          {chargesDetails?.taxAmount && chargesDetails?.total ? (
            <div className="payment-detail-wrap">
              <table className="table">
                <tr>
                  <td width="800">Tax</td>
                  <td width="140">${chargesDetails?.taxAmount}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>${chargesDetails?.total}</td>
                </tr>
              </table>
            </div>
          ) : null}

          <div className="payment-method-wrapper">
            <div className="section-heading">Payment Method</div>

            {authorizeCustomerProfile?.customerProfile?.profile?.paymentProfiles
              ?.length ? (
              authorizeCustomerProfile?.customerProfile?.profile?.paymentProfiles?.map(
                (card, index) => (
                  <>
                    <div className="card-wrapper primary" key={index}>
                      <label htmlFor={`primary-${index}`}>
                        <div className="card-left">
                          <label className="card-title">
                            Click to select card
                          </label>
                          <input
                            className="radioInput"
                            type="radio"
                            name="primary"
                            id={`primary-${index}`}
                            checked={
                              selectedCardId === card.customerPaymentProfileId
                            }
                            onChange={() =>
                              setSelectedCardId(card.customerPaymentProfileId)
                            }
                          />
                        </div>
                        <div className="card-right">
                          <div className="card-number">
                            XXXX XXXX {card?.payment?.creditCard?.cardNumber}
                          </div>
                          <div className="card-logo">
                            {card?.payment?.creditCard?.cardType}
                            {/* <MasterCardIcon /> */}
                          </div>
                        </div>
                      </label>
                    </div>
                  </>
                )
              )
            ) : (
              <p>
                You have not added any card yet, Please add card and select card
                to proceed.
              </p>
            )}

            <div className="add-new-card-form">
              <div className="add-new-title">🔒Secure Payment</div>
              <div className="add-new-title">Add New Card</div>
              <div className="add-new-card w-100">
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label>Card Number</Form.Label>
                    <Form.Control
                      type="text"
                      value={cardNumber}
                      placeholder="Enter Card Number"
                      onChange={(e) => handleCardNumber(e.target.value)}
                    />
                    <div className="payment-error">
                      {errors?.cardNumber ? errors.cardNumber : null}
                    </div>
                  </Col>
                  <Col md={4}>
                    <Form.Label>Expiry Month</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      value={cardMonth}
                      onChange={(e) => setCardMonth(e.target.value)}
                    >
                      <option>Select Month</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </Form.Select>
                  </Col>
                  <Col md={4}>
                    <Form.Label>Expiry Year</Form.Label>
                    <Form.Select
                      value={cardYear}
                      onChange={(e) => setCardYear(e.target.value)}
                      aria-label="Select Expiry Year"
                    >
                      <option value="">Select Year</option>
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </Form.Select>
                    <div className="payment-error">
                      {errors?.cardYear ? errors.cardYear : null}
                    </div>
                  </Col>
                  <Col md={4}>
                    <Form.Label>CVV</Form.Label>
                    <Form.Control
                      type="text"
                      value={cvv}
                      placeholder="Enter CVV"
                      onChange={(e) => setCvv(e.target.value)}
                    />
                    <div className="payment-error">
                      {errors?.cardCvv ? errors.cardCvv : null}
                    </div>
                  </Col>
                </Row>
                <div className="d-flex justify-content-between mt-3 align-items-center">
                  <Button variant="primary" onClick={handleAddCard}>
                    Add Card
                  </Button>
                </div>
                <div className="secured-payment d-flex justify-content-end align-items-center">
                  <span style={{ fontSize: "14px" }}>Powered By :</span>
                </div>
                <div className="secured-payment d-flex justify-content-end align-items-center">
                  <img
                    src={authorizelogo}
                    alt="Authorize Logo"
                    style={{ width: "100px", height: "auto" }}
                  />
                </div>
              </div>
            </div>
          </div>
          {location.state?.payload?.serviceName == "Child Care" ? (
            <Col xs={12}>
              <Form.Check
                inline
                type="checkbox"
                id=""
                label="Review Acknowledgment"
                value={policyChecked}
                checked={policyChecked}
                onClick={() => handleCheck()}
              />
            </Col>
          ) : null}

          {isOpen && (
            <div className="w-50 mx-auto">
              <Form.Label className="text-center w-100 danger">
                {isCouponApplied
                  ? "Code applied!"
                  : couponError
                  ? "Looks like that did not work!"
                  : "Enter a voucher code"}
              </Form.Label>

              <Form.Control
                type="text"
                value={couponCode.toUpperCase()}
                placeholder="Enter a voucher code"
                onChange={(e) => setCouponCode(e.target.value)}
                disabled={isCouponApplied}
              />
            </div>
          )}

          <div className="w-100 d-grid">
            <Button
              variant="primary"
              onClick={handleCouponCode}
              disabled={isCouponApplied}
              className="text-center"
            >
              Apply a voucher code
            </Button>
          </div>
          <div className="w-100 d-grid">
            <Button variant="primary" onClick={handleSubmit}>
              Confirm Booking
            </Button>
          </div>
        </div>
      </div>
      <Footer />
      {successModal ? (
        <SuccessModal
          providerId={id}
          serviceName={location.state?.payload?.serviceName}
          setSuccessModal={setSuccessModal}
          successModal={successModal}
          successResponse={successResponse}
          rate={serviceDetails?.rate}
        />
      ) : null}
      {policyModal ? (
        <Acknowlegment
          policyModal={policyModal}
          setPolicyChecked={setPolicyChecked}
          setPolicyModal={setPolicyModal}
        />
      ) : null}
    </>
  );
};

export default CheckOut;
